import { Calendar, User, FileIcon } from 'lucide-react';
import {FullFile} from "../api/ApiTypes.ts";
import {FileDownloadType, FileViewer} from "./FileViewer.tsx";
import {formatDateTime} from "../utils/dateUtils.ts";
import {MetadataRow} from "./MetaDataRow.tsx";
import {formatFileSize} from "../filehelper/fileutils.ts";

/**
 * FileItem Component - Displays a single file with details
 */
export const FileItem = ({ file }: { file: FullFile }) => {

    // Get the uploaded by full name
    const uploadedByName = [file.uploadedByFirstName, file.uploadedByLastName]
        .filter(Boolean)
        .join(' ') || 'System';

    // Skip hidden files
    if (file.hide) {
        return null;
    }

    return (
        <div className="border border-slate-200 rounded-lg bg-white mb-4 shadow-sm overflow-hidden">
            <div className="p-4">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    {/* File name and type */}
                    <div className="flex-1">
                        <div className="flex items-start space-x-3">
                            <div className="p-2 bg-blue-50 rounded-md flex-shrink-0">
                                <FileIcon className="h-6 w-6 text-blue-600" />
                            </div>
                            <div>
                                <h3 className="font-medium text-sm sm:text-base text-slate-800 break-all">
                                    {file.fileName}
                                </h3>
                                <p className="text-xs text-slate-500 mt-1">
                                    {file.fileTypeDescription} • {formatFileSize(file.fileSize)}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Action buttons */}
                    <div className="flex-shrink-0">
                        <FileViewer fileId={file.id} fileIs={FileDownloadType.APPRAISAL_FILE} />
                    </div>
                </div>

                {/* File metadata */}
                <div className="mt-4 pt-3 border-t border-slate-100 grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs">
                    <MetadataRow icon={<User className="h-4 w-4 mr-1 text-blue-500" />} label='Uploaded By:' value={uploadedByName}/>
                    <MetadataRow icon={<Calendar className="h-4 w-4 text-blue-500" />} label='' value={formatDateTime(file.uploadDateTime)}/>
                </div>
            </div>
        </div>
    );
};
